const LOADER_SELECTOR = '.b-checkout_benefits-loader';
let trapKeys = null;

export function showLoader() {
    const $loader = $(LOADER_SELECTOR);
    $loader.addClass('m-active');
    $loader.siblings().attr('inert', true);

    if (!trapKeys) {
        trapKeys = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
        document.addEventListener('keydown', trapKeys, true);
    }
}

export function hideLoader() {
    const $loader = $(LOADER_SELECTOR);
    $loader.removeClass('m-active');
    $loader.siblings().removeAttr('inert');

    if (trapKeys) {
        document.removeEventListener('keydown', trapKeys, true);
        trapKeys = null;
    }
}
